import HotkeyPlugin from 'v-hotkey3';

export default defineNuxtPlugin({
  name: 'v-hotkey',
  setup(nuxtApp) {
    nuxtApp.vueApp.use(HotkeyPlugin);
  },
});
